<div class="relative flex flex-col justify-center overflow-hidden py-16 sm:py-20 lg:py-24 h-[60vh] bg-cover bg-center bg-no-repeat" style="background-image: url('pexels-expect-best-79873-323780.jpg');">
  <div class="absolute inset-0 bg-bg-base/60 backdrop-blur-sm z-0"></div>
  <!-- Premium background glow effects -->
  <div class="absolute inset-0 opacity-20 pointer-events-none">
    <div
      class="absolute -top-20 -left-20 w-[420px] h-[420px] bg-primary-soft rounded-full blur-[130px]"
    ></div>
    <div
      class="absolute -bottom-20 -right-20 w-[420px] h-[420px] bg-primary-deep rounded-full blur-[140px]"
    ></div>
  </div>

  <!-- Content Wrapper -->
  <div class="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
    <h1
      class="h1 tracking-tight drop-shadow-primary-glow"
    >
      <span class="text-transparent bg-clip-text bg-gradient-to-r from-text-primary to-text-secondary">
        {{ 'about.header.title' | translate }}
      </span>
    </h1>

    <p class="mt-6 body-large max-w-3xl mx-auto text-text-secondary">
      {{ 'about.header.subtitle' | translate }}
    </p>

    <!-- Accent Line -->
    <div class="mt-8 mx-auto w-24 h-1 bg-gradient-to-r from-primary to-primary-deep rounded-full shadow-primary-glow"></div>
  </div>
</div>
